import GameBadge from "@casino/client/components/GameCard/GameBadge";
import { getGameTitle } from "@casino/client/components/GameCard/getGameTitle";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import Img from "@casino/legacy/client/shared/images/Img";
import GameImageContainer from "../GameImageContainer";
import type GameThumbProps from "../GameThumbProps";
import Hover from "../Hover";
import useGameThumb from "../hooks/useGameThumb";

const MediumThumb: FC<GameThumbProps> = (props) => {
  const {
    game,
    isHoverEnabled,
    preloadImg,
    isBadge = true,
  } = useGameThumb(props);
  const { isMobile } = useAgentData();
  const { title } = getGameTitle(game.name ?? "");
  const providerName = game.menuItem?.[0]?.name;

  const width = isMobile ? 104 : 244;
  const height = isMobile ? 140 : 188;

  return (
    <div className="relative shrink-0 cursor-pointer rounded-lg overflow-hidden flex justify-center max-w-26 max-h-35 sm:max-w-61 sm:max-h-47">
      {isHoverEnabled && (
        <Hover game={game} gameHref={props.href ?? game.href ?? ""} />
      )}
      <GameImageContainer {...props} className="-mx-1 xxsm:-mx-2 sm:mx-0">
        <Img
          preload={preloadImg}
          src={game.thumbUrlMob ?? ""}
          alt={game.name ?? ""}
          useDpr2x
          width={width}
          height={height}
          fit="crop"
          crop="faces"
          className="w-full"
        />
      </GameImageContainer>
      <div
        className="absolute inset-0 bg-[linear-gradient(180deg,transparent_31.73%,#000_100%)] pointer-events-none z-1"
        aria-hidden
      />
      <div className="absolute inset-0 z-2 flex flex-col items-center px-2 pb-2 pointer-events-none">
        <div className="relative w-full h-6">
          {isBadge && <GameBadge game={game} />}
        </div>
        {title && (
          <div className="mt-auto flex flex-col items-center gap-1">
            <p className="text-center uppercase font-black font-big-shoulders text-white whitespace-pre-line text-[20px] leading-[0.97] sm:text-[32px]">
              {title}
            </p>
            {providerName && (
              <p className="text-center text-[10px] font-semibold leading-3 text-white/80">
                {providerName}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MediumThumb;
